import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=5b53653e&scoped=true&"
import script from "./prescription.vue?vue&type=script&lang=js&"
export * from "./prescription.vue?vue&type=script&lang=js&"
import style0 from "./prescription.vue?vue&type=style&index=0&id=5b53653e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b53653e",
  null
  
)

export default component.exports